<template>
  <div class="topbar">
    <KeywordFilter :lookup="'landlords/fetch'" :limit="landlordsLimit"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{landlords.total}}</template>
      </counters>
      <!--<div class="buttonset">
        <router-link class="buttonset__button btn btn--main" :to="{ name: 'add-landlord' }">{{ $t('top_bar.add_new_landlord') }}</router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import KeywordFilter from 'common/KeywordFilter';

export default {
  components: {
    Autocomplete,
    Counters,
    KeywordFilter,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    landlords: 'landlord/landlords/landlords',
    landlordsLimit: 'landlord/landlords/limit',
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/landlords/Topbar.vue